// STYLES
import {
  CarouselWrapper,
  CivicDialogueContainer,
  ScrollWrapper,
  SectionId,
  SectionsRow2,
} from "./CivicDialogueStyled";

// LIBRARIES

import { useTranslation } from "react-i18next";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { cards } from "./CivicDialogueModel";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import CivicDialogueCardsSection from "components/CivicDialogueCardsSection/CivicDialogueCardsSection";
import CollabSection from "components/CollabSection/CollabSection";
import HeroCarousel from "components/HeroCarousel/HeroCarousel";
import LastTitles from "components/LastTitles/LastTitles";
import VolunteerSection from "components/VolunteerSection/VolunteerSection";
import ProductsSections from "components/ProductsSections/ProductsSections";
import ScrollCardsMenu from "components/ScrollMenu/ScrollCardsMenu";

// CONFIGURATION

const CivicDialogue = () => {
  // PROPERTIES

  // API REQUESTS

  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // STATE CONSTANTS
  const sectionCards = [
    { id: "carousel-section", title: t("view.navButtons.campaigns") },
    { id: "volunteer-section", title: t("view.navButtons.volunteer") },
    { id: "cards-section", title: t("view.navButtons.internship") },
    { id: "collab-section", title: t("view.navButtons.colabs") },
    { id: "titles-section", title: t("view.navButtons.law") },
    { id: "products-section", title: t("view.navButtons.products") },
  ];

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <CivicDialogueContainer>
      <ScrollWrapper>
      <ScrollCardsMenu cards={sectionCards} />
      </ScrollWrapper>
      <SectionsRow2>
            
      {/* <CustomText
        type={TextType.H2}
        text={t("view.civicDialogue")}
        color={COLORS.Crimson}
      /> */}
      <SectionId id="carousel-section">
        <CustomText
          type={TextType.H3}
          text={"Campanii"}
          color={COLORS.RaisinBlack}
        />
        <CarouselWrapper>
          <HeroCarousel isHomePage={false} />
        </CarouselWrapper>
      </SectionId>
      <SectionId id="volunteer-section">
        <VolunteerSection />
      </SectionId>
      <SectionId id="cards-section">
        <CivicDialogueCardsSection cards={cards} />
      </SectionId>
      <SectionId id="collab-section">
        <CollabSection />
      </SectionId>
      <SectionId id="titles-section">
        <LastTitles />
      </SectionId>
      <SectionId id="products-section">
        <ProductsSections />
      </SectionId>
      </SectionsRow2>
    </CivicDialogueContainer>
  );
};

export default CivicDialogue;
